import { useEffect } from "react";

import { type ApolloError, useLazyQuery } from "@apollo/client";

import { getRemoteAssetLensUsages } from "../api/queries/getRemoteAssetLensUsages";
import {
    type GetRemoteAssetLensUsagesQuery,
    type GetRemoteAssetLensUsagesQueryVariables,
} from "../api/queries/getRemoteAssetLensUsages.gql-generated";

import { LENS_USAGE_LIMIT, type LensUsage } from "./remoteAssetLensUsageShared";

interface UseRemoteAssetLensUsagesResult {
    lenses: readonly LensUsage[];
    loading: boolean;
    error: ApolloError | undefined;
}

export const useRemoteAssetLensUsages = (assetId: string): UseRemoteAssetLensUsagesResult => {
    const [execute, { data, loading, error }] = useLazyQuery<
        GetRemoteAssetLensUsagesQuery,
        GetRemoteAssetLensUsagesQueryVariables
    >(getRemoteAssetLensUsages, {
        fetchPolicy: "cache-first",
    });

    useEffect(() => {
        if (!assetId) return;

        void execute({
            variables: {
                id: assetId,
                cursor: null,
                limit: LENS_USAGE_LIMIT,
            },
        });
    }, [assetId, execute]);

    return {
        lenses: data?.remoteAsset?.usedByLensesConnection.nodes ?? [],
        loading,
        error,
    };
};
